// extracted by mini-css-extract-plugin
module.exports =  {"group-label":"c8Wb2ke","groupLabel":"c8Wb2ke"};